import { FC } from 'react';
import { ErrorMessageStyled } from './ErrorMessage.styled';
import { IChildren } from '../../../../../interfaces/common/common';

export const ErrorMessage : FC<IChildren> = ({children}) => {
  return <ErrorMessageStyled>{children}</ErrorMessageStyled>
}